<template>
  <div v-if="showAction()">
    <!-- Admin Sent Profile -->
    <div v-if="jobStatus() == 'doneSentProfile'">
      <el-col :span="1.5">
        <el-button class="resend-button" size="medium" type="danger" style="margin-right: 8px; padding: 0px !important;" :disabled="disabled || fake" @click.native.prevent="resendProfileButtonClick">
          <img src="https://storage.healthathome.in.th/7b271945-a7d7-436d-953e-1c521558a972.svg" alt="">
          <span style="margin-left: 8px;">ส่งโปรไฟล์ซํ้า</span>
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button class="accept-cg-button" size="medium" type="danger" style="padding: 0px !important;" :disabled="fake" @click.native.prevent="acceptButtonClick">
          <img src="https://storage.healthathome.in.th/45449e2f-61fe-48f6-94ca-2cb528e658b4.svg" alt="">
          <span style="margin-left: 8px;">แมทช์ชิ่ง</span>
        </el-button>
      </el-col>
    </div>
    <div v-if="jobStatus() == 'customerReject'" class="admin-customer-reject-container">
      <el-button class="admin-customer-reject" size="medium" disabled>
        <img src="https://storage.healthathome.in.th/64c481b4-8d4c-4626-93ae-69a0106d01e3.svg" alt="">
        <span style="margin-left: 8px;">ลูกค้าปฏิเสธ</span>
      </el-button>
      <MatchingCustomerFeedback :itemData="feedback"/>
    </div>

    <!-- Waiting Admin Send Profile -->
    <div v-if="jobStatus() == 'readyToSendProfile'">
      <el-col :span="1.5">
        <el-button class="match-reject-button" size="medium" type="primary" :disabled="disabled || fake" style="margin-right: 8px; padding: 0px !important;" @click.native.prevent="sendProfileButtonClick">
          <img src="https://storage.healthathome.in.th/ad50c75c-fe4b-4019-a3d7-923d7be4a759.svg" alt="">
          <span style="margin-left: 8px;">ส่งโปรไฟล์</span>
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button class="reject-cg-button" size="medium" type="danger" style="padding: 0px !important;" :disabled="fake" @click.native.prevent="rejectButtonClick">
          <img src="https://storage.healthathome.in.th/639d6705-dab2-49d1-9b52-2413d1a55164.svg" alt="">
          <span style="margin-left: 8px;">ปฏิเสธผู้ดูแล</span>
        </el-button>
      </el-col>
    </div>

    <!-- Admin Reject CG -->
    <div v-if="jobStatus() == 'adminReject'">
      <el-col :span="1.5">
        <el-button class="admin-customer-reject" size="medium" disabled>
          <img src="https://storage.healthathome.in.th/64c481b4-8d4c-4626-93ae-69a0106d01e3.svg" alt="">
          <span style="margin-left: 8px;">แอดมินปฏิเสธ</span>
        </el-button>
      </el-col>
    </div>

    <!-- CG Reject Job -->
    <div v-if="jobStatus() == 'cgReject'">
      <el-row>
        <el-button class="cg-reject" size="medium" disabled>ผู้ดูแลปฏิเสธ</el-button>
      </el-row>
    </div>
  </div>

  <!-- No Action -->
  <div v-else>
    <el-col :span="2.5">
      <el-row v-if="itemData.status === 'seen'">
        <el-button class="noaction" size="medium" icon="el-icon-view"/>
      </el-row>
      <el-row v-if="itemData.status === 'rejected'">
        <el-button class="noaction" size="medium" icon="el-icon-close"/>
      </el-row>
    </el-col>
  </div>
</template>

<style lang="scss" scoped>
  .admin-customer-reject-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .resend-button, .accept-cg-button {
    font-size: 12px !important;
    height: 32px;
    width: 107px;
    padding: 10px 4px !important;
    background-color: #E9EAED;
    border: 1.5px solid #E9EAED !important;
    color: #A2A7B2;

    &:hover {
      opacity: 0.6;
    }
  }

  .reject-cg-button {
    font-size: 12px !important;
    height: 32px;
    width: 107px;
    padding: 10px 4px !important;
  }

  .match-reject-button, .match-reject-button:focus {
    font-size: 12px !important;
    height: 32px !important;
    width: 107px;
    padding: 10px 4px !important;
  }

  .noaction {
    font-family: 'Sukhumvit-Bold';
    background-color: white;
    color: #c0c4cc;
    border: 1.5px solid #c0c4cc !important;
    font-size: 20px;
    width: 107px;
    height: 32px;
    padding: 6px 4px !important;
    pointer-events: none;
  }

  .cg-reject {
    background-color: white;
    color: #c0c4cc;
    border: 1.5px solid #c0c4cc !important;
    font-size: 12px;
    width: 107px;
    height: 32px;
    padding: 8px 4px !important;
    pointer-events: none;
  }

  .admin-customer-reject {
    background-color: white;
    color: #FF577F;
    border: 1.5px solid #FF577F !important;
    font-size: 12px;
    width: 107px;
    height: 32px;
    padding: 8px 4px !important;
    pointer-events: none;
  }
</style>

<script>
import MatchingCustomerFeedback from '@/components/matching/MatchingCustomerFeedback'
export default {
  name: 'MatchingLineActionPanel',
  components: {
    MatchingCustomerFeedback,
  },
  props: {
    itemData: {
      type: Object,
      required: true,
    },
    itemIndex: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fake: {
      type: Boolean,
      required: true,
    },
    feedback: {
      type: Array,
      required: true,
    },
  },
  methods: {
    acceptButtonClick () {
      this.$emit('acceptButtonClick', this.itemIndex, this.itemData)
    },
    sendProfileButtonClick () {
      this.$emit('sendProfileButtonClick', this.itemIndex, this.itemData)
    },
    rejectButtonClick () {
      this.$emit('rejectButtonClick', this.itemIndex, this.itemData)
    },
    resendProfileButtonClick () {
      this.$emit('resendProfileButtonClick', this.itemIndex, this.itemData)
    },
    showAction () {
      if (this.itemData.status !== 'seen' && this.itemData.status !== 'new' && this.itemData.status !== 'rejected') {
        return true
      }
      return false
    },
    jobStatus () {
      if (this.itemData.sentProfileAt !== '') {
        if (this.itemData.status === 'customerRejected') {
          return 'customerReject'
        } else { return 'doneSentProfile' }
      } else {
        switch (this.itemData.status) {
          case 'cgAccepted': return 'readyToSendProfile'
          case 'unmatched': return 'adminReject'
          case 'cgRejected': return 'cgReject'
          default : return ''
        }
      }
    },
  },
}
</script>
